import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function AppFooter() {
  const { t } = useTranslation();

  const productLinks = [
    { label: t("footer.productApply"), to: "/apply" },
    { label: t("footer.productLicenses"), to: "/licenses" },
    { label: t("footer.productMonitor"), href: "#status" },
    { label: t("footer.productReports"), href: "#activity" },
  ];

  const helpLinks = [
    { label: t("footer.helpGuide"), to: "/help#quickstart" },
    { label: t("footer.helpFaq"), to: "/help#faq" },
    { label: t("footer.helpDocs"), to: "/docs/integration" },
    { label: t("footer.helpTicket"), to: "/help#contact" },
  ];

  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto grid w-full gap-10 px-4 py-14 md:grid-cols-2 lg:grid-cols-4 md:px-6">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-shield-keyhole-line text-lg" />
            </span>
            <span className="font-heading text-lg font-semibold text-background-50">LicenseHub</span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-background-300">{t("footer.tagline")}</p>
          <div className="mt-5 flex flex-wrap gap-2">
            <span className="rounded-full bg-primary-900/70 px-3 py-1 text-xs text-background-200">
              {t("footer.badgeSecurity")}
            </span>
            <span className="rounded-full bg-primary-900/70 px-3 py-1 text-xs text-background-200">
              {t("footer.badgeUptime")}
            </span>
          </div>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">{t("footer.colProduct")}</h4>
          <ul className="mt-4 space-y-3 text-sm">
            {productLinks.map((link) =>
              link.to ? (
                <li key={link.label}>
                  <Link to={link.to} className="text-background-300 transition-colors hover:text-background-50">
                    {link.label}
                  </Link>
                </li>
              ) : (
                <li key={link.label}>
                  <a href={link.href} className="cursor-pointer text-background-300 transition-colors hover:text-background-50">
                    {link.label}
                  </a>
                </li>
              ),
            )}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">{t("footer.colHelp")}</h4>
          <ul className="mt-4 space-y-3 text-sm">
            {helpLinks.map((link) =>
              link.to ? (
                <li key={link.label}>
                  <Link to={link.to} className="text-background-300 transition-colors hover:text-background-50">
                    {link.label}
                  </Link>
                </li>
              ) : (
                <li key={link.label}>
                  <a href={link.href} className="cursor-pointer text-background-300 transition-colors hover:text-background-50">
                    {link.label}
                  </a>
                </li>
              ),
            )}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold text-background-50">{t("footer.colSupport")}</h4>
          <p className="mt-4 text-sm text-background-300">{t("footer.supportDesc")}</p>
          <Link
            to="/help"
            className="mt-4 inline-flex cursor-pointer items-center gap-2 rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-accent-950 transition-colors hover:bg-accent-400"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-customer-service-2-line" />
            </span>
            {t("footer.supportBtn")}
          </Link>
        </div>
      </div>

      <div className="border-t border-primary-800/60">
        <div className="mx-auto flex w-full flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-400 sm:flex-row md:px-6">
          <p>{t("footer.copyright")}</p>
          <div className="flex flex-wrap items-center justify-center gap-5">
            <Link to="/help" className="cursor-pointer transition-colors hover:text-background-100">
              {t("footer.terms")}
            </Link>
            <Link to="/help" className="cursor-pointer transition-colors hover:text-background-100">
              {t("footer.privacy")}
            </Link>
            <Link to="/help#contact" className="cursor-pointer transition-colors hover:text-background-100">
              {t("footer.contact")}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}